import React from "react";

const Header = () => {
  const handleConnectTelegram = () => {
    window.location.href =
      window.open("https://telegram.me/dotswap_trade_bot?start=connect", "_blank");
  };

  return (
    <header className="sticky top-0 z-50 bg-gradient-to-r from-gray-900 to-gray-800 shadow-lg p-2 sm:p-4 flex flex-col sm:flex-row justify-between items-center">
      <div className="flex items-center space-x-2 mb-2 sm:mb-0">
        <a href="https://bitcoinuniverse.io" className="flex items-center">
          <img
            src="https://bitcoinuniverse.io/static/media/logo.e12ac5ee857670720904.png"
            alt="Bitcoin Universe Logo"
            className="h-8 sm:h-10"
          />
          <span className="text-xl sm:text-2xl font-bold text-pink-500 ml-2">
            🆄🅽🅸🆅🅴🆁🆂🅴
          </span>
        </a>
      </div>
      <div className="text-base sm:text-lg font-semibold text-center mb-2 sm:mb-0 hidden sm:block">
        Leaderboard for Elite Traders
      </div>
      <div className="flex items-center space-x-2 sm:space-x-4">
        <button
          onClick={handleConnectTelegram}
          className="bg-pink-600 hover:bg-pink-700 text-white px-3 py-1 sm:px-4 sm:py-2 rounded-lg flex items-center text-sm sm:text-base"
        >
          <i className="fab fa-telegram-plane mr-1 sm:mr-2"></i> Connect
          Telegram
        </button>
      </div>
    </header>
  );
};

export default Header;
